export default {
	init() {
		// JavaScript to be fired on all pages
		$('.scroll-link').click(function(e){
			console.log('found it');
			var href = $(this).attr('href');
			var offset = $(href).offset().top;
			$("html,body").animate({scrollTop:offset - 100}, 500);
			e.preventDefault();
		});
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js